'use client'

import React from 'react'
import Image from 'next/image'
import { RIGHT_ARROW_URL } from '@constants/contactUs.constants'
import styles from './QuickActions.module.scss'

const FaqButton = ({ btn, handleClick }) => {
  const { url, alternativeText } = btn?.icon?.data?.attributes || {}
  const handleFaqClick = () => {
    handleClick(btn.text)
  }
  return (
    <button type="button" key={btn.id} className={styles.faqButton} onClick={handleFaqClick}>
      <div className={styles.iconContainer}>
        {!!url && <Image src={url} height={24} width={24} alt={alternativeText || 'faq-icon'} />}
        <span className={styles.buttonText}>{btn.text}</span>
      </div>
      <Image src={RIGHT_ARROW_URL} alt="right-arrow" width={24} height={24} />
    </button>
  )
}

export default FaqButton
